import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack } from "@mantine/core";
import ClientDashboardTitle from "./components/ClientDashboardTitle";
import CoinCard from "./components/CoinCard";
import CurrentStepProgressCard from "./components/CurrentStepProgressCard";
import NextUserRewardCard from "./components/NextUserRewardCard";
import OrderTable from "./components/OrderTable";

const MyOrders: React.FC = () => {
  const { t } = useAppTranslation("pages.clientDashboard");

  return (
    <Stack>
      <ClientDashboardTitle
        icon={
          <AppThemeIcon className="size-8">
            <Icon.Bag />
          </AppThemeIcon>
        }
        label={t("orders.title")}
        subHeader={t("orders.subHeader")}
      />
      <Group align="stretch">
        <CoinCard
          containerProps={{
            classNames: {
              root: "w-full xs:w-auto ",
              wrapper: "w-full xs:w-auto",
            },
          }}
        />
        <NextUserRewardCard
          containerProps={{
            classNames: {
              root: "flex-1 xs:flex-none xl:flex-[0.8]",
            },
          }}
        />
        <CurrentStepProgressCard
          containerProps={{
            classNames: {
              root: "xs:flex-none xl:flex-1",
            },
          }}
        />
      </Group>

      <OrderTable />
    </Stack>
  );
};

export default MyOrders;
